export default "__VITE_ASSET__djJmtWPW__"